import React from 'react';
import { View } from 'react-native';
const WebView = () => <View />;
export { WebView };
